import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';

function Header() {
  return (
    <>
      <h3 className="px-4 pt-4 text-xl font-semibold">
        <T kind="Add Participants" />
      </h3>
      <p className="px-4 pb-4 text-sm">
        <T kind="Add participants to the group by finding them in the search field below." />
      </p>
    </>
  );
}

export default observer(Header);
